module.exports = __webpack_public_path__ + "static/assets/0bd9efb05af40a9a1a48c14b2636f485.png";